import lottie from "./lottie";
// -----------------------------------------------------------------------------
export default {
  lottie: {
    plugin: lottie,
    options: {}
  }
};
